import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=af79486e&scoped=true&"
import script from "./LoginMessage.vue?vue&type=script&lang=js&"
export * from "./LoginMessage.vue?vue&type=script&lang=js&"
import style0 from "./LoginMessage.vue?vue&type=style&index=0&id=af79486e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af79486e",
  null
  
)

export default component.exports